import { Suspense } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';

import { ErrorPage } from '~/components/ErrorPage';

import { ChatbotPage } from '../pages/chatbot-page/ChatbotPage';

export function Router() {
  return (
    <Suspense>
      <Routes>
        <Route element={<Outlet />}>
          <Route index element={<ChatbotPage />} />
          <Route path="*" element={<ErrorPage type="notFoundPage" />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

Router.displayName = 'MusicIqRouter';
